var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 446.4 589.4",
    style: {
      enableBackground: "new 0 0 446.4 589.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.net0{fill:none;stroke:#C6C6C6;stroke-width:2;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Netz"
  }, /*#__PURE__*/React.createElement("path", {
    className: "net0",
    d: "M201.8,589.3c0,0-59.5-209.5-24.3-328.4c0,0,146-162.2,152.7-243.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "net0",
    d: "M380.2,520.3c0,0-77-46-89.2-70.3s-63.5-110.8-75.7-118.9s-20.2-56.7-37.8-70.3 c-17.6-13.5-60.8-43.2-64.9-67.6s-12.2-43.2-18.9-50s-43.2-4-48.6-33.8S24.8,81.1,24.8,81.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "net0",
    d: "M132.9,0.1c2.7,20.3,8.1,66.2,9.5,83.8s18.9,56.8,18.9,77s4.1,87.8,16.2,100c12.2,12.2,82.4,36.6,90.5,40.6 s62.2,68.9,74.3,75.7s85.1,60.8,85.1,60.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "net0",
    d: "M126.2,437.9c0,0-10.8-23,1.4-55.4s33.8-59.5,33.8-74.3s16.2-47.3,16.2-47.3s37.8-25.7,55.4-25.7 s89.2-1.4,98.6-8.1S435.6,169,446.5,169"
  }), /*#__PURE__*/React.createElement("path", {
    className: "net0",
    d: "M370.7,514.2c0,0-17.1-30.7-4.3-50s30.7-50,30.7-50s-15-62.1-10-83.5s42.1-138.3,38.5-153.3 c0,0-34.2-27.1-51.4-34.2s-27.1-18.6-27.1-29.3s-16.4-31.4-16.4-38.5s3.6-44.2-0.7-52.1c0,0-155.2,32.8-194.5-7.1 c0,0-16.6,117.5-46.6,124.6c0,0,23.4,56.6,17.7,68.8s-5.7,33.5-3.6,45c2.1,11.5,4.3,22.1,0,36.4c0,0-5.7,26.4,6.4,45 s17.1,41.4,15,57.1c0,0,27.1,87.1,56.4,104.9c0,0,3.6-12.1,47.8-11.4S326.4,520,370.7,514.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "net0",
    d: "M92,293.8c0,0,6.1-17.2,1.8-29.3c-4.3-12.1-20.7-20.7-21.4-30s0.7-22.8-5-22.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "net0",
    d: "M113.8,343c0,0,4.3,25,2.9,37.1s-15.7,16.4-15.7,22.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "net0",
    d: "M185.1,493.7c0,0,57.1-0.1,72.1,9.9s77.8,27.8,116.3,15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "net0",
    d: "M172.3,440c0,0,15-15,36.4-15.7s58.5,12.8,74.2,11.4c0,0,5-24.3,15.7-32.8s39-8.4,50.4-21.3 c0,0-1.9-155,33.8-183.5c0,0-31.4-20-40-32.8s-12.8-64.2-36.4-80.6c0,0-124.9,12.5-167-29.3c0,0-12.1,31.8-12.8,59.6 s10.7,74.2-6.4,94.2c0,0,7.3,49.6-4.8,80.3c0,0,19.8,46,14.1,88.1c0,0,8.6,14.3,12.9,27.8S160.2,426.8,172.3,440z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "net0",
    d: "M168.2,400.3c0,0,50.5-34.3,75.5-30.7c0,0-4.4-59.1,30.6-62.6c0,0,0.7-22.1,6.4-31.4s24.3-24.3,24.3-42.8 c0,0-15-31.4-20.7-50s-1.4-34.2-10-45.7c0,0-104.1-28.7-132-53.3c0,0-4.3,71.8-0.8,90.4c3.6,18.6-7.1,52.1-7.1,52.1 s6.8,49.1-2.5,62.7c0,0,12.6,47.1,9.1,64.2C141.1,353.2,169.7,381.7,168.2,400.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "net0",
    d: "M170.1,424c0,0,72.1-25.7,104.9-1.4c0,0-10-66.4,21.4-92.1c0,0-15-23.5,0.7-46.4s19.3-53.5,19.3-53.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "net0",
    d: "M330,366.9c0,0,2.9-144.1,39.2-162c0,0-0.7-40.7-11.4-47.1s-47.1-64.2-46.4-84.9c0,0-127.7,12.1-172.7-22.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "net0",
    d: "M166.6,368.3c0,0,35.7-28.5,57.8-26.4c0,0-4.3-35,9.3-53.5c0,0,2.1-18.6,11.4-22.1s27.1-32.1,27.1-32.1 s-24.3-30-31.4-50c0,0-36.4-14.3-44.2-20s-26.4-18.6-37.1-17.8c0,0-2.9,74.2-19.3,84.2c0,0,8.6,37.8,5.7,50.7 c0,0,5.7,32.1,5.7,52.8C151.6,334.1,168,351.9,166.6,368.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "net0",
    d: "M230.8,349c0,0,1.4-47.8,14.3-57.1c0,0,13.6-11.4,27.1-57.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "net0",
    d: "M167.3,335.5c0,0,24.3-14.3,39.2-13.5c0,0,13.6-27.1,14.3-39.2c0,0,8.5-47.5,12.1-47.5s-5.8,1-5.8,1 s4.4-22.7-3.5-30.5c0,0-25.7-7.1-33.5-12.1S161.6,180,161.6,180s0,47.8-8.6,60.6c0,0,4.3,18.6-1.4,37.8c0,0,8.6,22.1,8.6,37.1 C160.2,315.5,165.1,314.1,167.3,335.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "net0",
    d: "M201.6,306.9c0,0-2.9-17.1,5.7-30.7c0,0,9.3-22.8,8.6-37.1c0,0-1.5-0.4-2.3-20.4c0,0-43.4,1.1-49.1-11.8 c0,0,4.3,31.4-0.7,42.8c0,0,2.1,2.9-2.9,23.5c0,0,5.3,5.9,2.8,21.4c0,0,4.8,3.7,4.8,15.9C168.5,310.7,190.1,296.2,201.6,306.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "net0",
    d: "M212.2,277c0,0,2.9-35,9.3-39.2c0,0,2.9-23.5-2.9-27.1c0,0-51.4-14.3-56.4-23.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "net0",
    d: "M343.5,523.1c0,0-130,41.3-149.9,31c0,0-52.6-58.7-52.6-86.3s-19.2-56-19.2-56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "net0",
    d: "M55.5,299.6c0,0-13.8-90.6,2.6-113s16.4-50,16.4-50s22.4-25,31.9-44s27.6-82,27.6-82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "net0",
    d: "M68,300.1c0,0,48.8,63.4,45.3,88.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "net0",
    d: "M169.7,297c0,0,23.2-5.2,28.4,1.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "net0",
    d: "M192.9,284.4c0,0-4.3-7.7,2.6-12c0,0,7.5-7.5,8.6-11.2s2.3-14.6,3.4-18.1c-2-4.6-2.6-9.7-1.7-14.6 c0,0-30.7,7.2-39-1.7c0,0,2,20.1,0.6,25.8c0.5,5.3,0.2,10.6-0.9,15.8c0,0,2.3,3.4,2.6,10.9c0,0,2.6-3.4,2.6,7.7 C171.7,287,185.8,277,192.9,284.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "net0",
    d: "M187.2,271.8c0,0,0.3-1.7,3.2-2.3c0,0,5.7-4.9,5.7-8.3s0-9.7,0.3-11.7c0,0-4.3,0.6-4.3-6.3 c0,0-18.9,5.2-22.1,2c0,0,1.7,6.6,0.3,10c0,0,1.4,6,0.6,10.3c0,0-1.4,5.5,0.6,6.3l1.7,5.2C173.1,276.9,177.2,271.8,187.2,271.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "net0",
    d: "M176,268.1c0,0,6.3-1.1,8-2.9s6.9-7.5,6.9-11.8c0.2-2-1.4-3.8-3.4-4c-0.2,0-0.4,0-0.6,0c0,0-12.9-3.2-14,1.4 s0.3,12,0.3,12c2.2,1.2,4.8,1.4,7.2,0.6c3.7-1.4,6-5.2,5.5-7.2c-0.5-2-10.3-4.6-10.3-1.1c0,2.1,0.7,4.1,2.1,5.7 c-2,1.3-36.2,30.4-52.7,28.4c-17.5-2.1-44.7,9.5-56.8,10.8c-12.4,1.4-35.2-6.2-45.9,0c-11,6.4-21.6,40.5-21.6,40.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "net0",
    d: "M161.3,160.9c0,0,65.1,29.4,74.2,30"
  }), /*#__PURE__*/React.createElement("path", {
    className: "net0",
    d: "M297,100.9c0,0,12.8,115.4,34.6,126.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "net0",
    d: "M315.2,474.9c0,0,58.4-62.8,79.6-61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "net0",
    d: "M150.9,114.2c0,0,79,35.6,119,29.6c0,0,4,37.1,21.6,58.3"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNet);
export default __webpack_public_path__ + "static/media/net.8afacdc6.svg";
export { ForwardRef as ReactComponent };